class MiniMessagePoster {
    static useIframeResizer;

    static initEventListeners() {
        this.useIframeResizer = document.body.classList.contains('iFrameResizer');
        if (brandLabel !== 'mini' || this.useIframeResizer) { return; }
        // resize events
        document.addEventListener('DOMContentLoaded', MiniMessagePoster.triggerResizeParent);
        window.addEventListener('resize', MiniMessagePoster.triggerResizeParent);
        window.addEventListener('load', MiniMessagePoster.triggerResizeParent);

        // scroll to top when loading new page in iframe
        document.addEventListener('DOMContentLoaded', function () {
            MiniMessagePoster.scrollToTop();
        });
    }
    static triggerResizeParent() {
        if (brandLabel !== 'mini' || this.useIframeResizer) { return; }
        setTimeout(function () {MiniMessagePoster.resizeParentIframe()}, 500);
        setTimeout(function () {MiniMessagePoster.resizeParentIframe()}, 1000);
        setTimeout(function () {MiniMessagePoster.resizeParentIframe()}, 2000);
    }
    static resizeParentIframe() {
        if (brandLabel !== 'mini' || this.useIframeResizer) { return; }
        const height = document.body.scrollHeight;
        const data = {
            'child_origin': 'parentSize',
            'actions': [{
                'action': 'resize',
                'params': {
                    'height': height + 'px'
                }
            }],
            'callback': true
        };
        const stringData = JSON.stringify(data);
        window.parent.postMessage(stringData,'https://www.' + brandLabel + '.fr');
    }
    static scrollToTop() {
        if (brandLabel !== 'mini' || this.useIframeResizer) { return; }
        const data = {
            'child_origin': 'parentSize',
            'actions': [{
                'action': 'scrollTo',
                'params': {
                    'offset': {
                        'top': -100 // offset from top of iframe body
                    }
                }
            }
            ],
            'callback': true
        };
        const stringData = JSON.stringify(data);
        window.parent.postMessage(stringData,'https://www.mini.fr');
    }

}
export default MiniMessagePoster;
